import { COLORS } from "../../common/constants";

export const styles = {
  loaderContainer: {
    zIndex: "9999",
    color: COLORS.white,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    position: "fixed",
  },
  loaderImage: {
    width: "200px",
    height: "200px",
    margin: "0 auto",
  },
};
